import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import {
    GetCentroCustoResponse,
    CreateCentroCustoResponse,
} from '../../responses/financas/get-centro-custo.response';
import { DeleteCentroCustoResponse } from '../../responses/financas/delete-centro-custo.response';
import { BulkDeleteCentroCustoResponse } from '../../responses/financas/bulk-delete-centro-custo.response';
import { CentroCustoRequest } from '../../requests/financas/centro-custo.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class CentroCustoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'CentroCusto';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(pesquisa: string = '', pagina: number = 0, tamanhoPagina: number = 20): Observable<GetCentroCustoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (pesquisa) {
            params = params.set('pesquisa', pesquisa);
        }

        return this.httpClient
            .get<GetCentroCustoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateCentroCustoResponse> {
        const url = `${this.apiUrl}/idCentroCusto/${id}`;
        return this.httpClient
            .get<CreateCentroCustoResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: CentroCustoRequest): Observable<CreateCentroCustoResponse> {
        return this.httpClient
            .post<CreateCentroCustoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: CentroCustoRequest): Observable<CreateCentroCustoResponse> {
        const url = `${this.apiUrl}/idCentroCusto/${id}`;
        return this.httpClient
            .put<CreateCentroCustoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<DeleteCentroCustoResponse> {
        const url = `${this.apiUrl}/idCentroCusto/${id}`;
        return this.httpClient
            .delete<DeleteCentroCustoResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public inativar(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/inativar/${id}`;
        return this.httpClient
            .put<ReturnStruct>(url, {}, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public bulkInativar(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-inativar`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public bulkDelete(ids: number[]): Observable<BulkDeleteCentroCustoResponse> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<BulkDeleteCentroCustoResponse>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
